import { PermissionRoleListPayload, SetPermissionInRolePayload } from "../../../types/permissions/permissionRoleInterface";
import { PermissionRoleActionTypes, PermissionRoleActions } from "../../actionTypes/permissions/permissionRoleActionTypes";


export const getPermissionRoleList = (departmentId: number): PermissionRoleActionTypes => ({
  type: PermissionRoleActions.GET_PERMISSION_ROLE_LIST,
  payload: departmentId 
});

export const setPermissionRoleList = (payload: PermissionRoleListPayload): PermissionRoleActionTypes => ({
  type: PermissionRoleActions.SET_PERMISSION_ROLE_LIST,
  payload
})

export const setPermissionRole = (payload: SetPermissionInRolePayload): PermissionRoleActionTypes => ({
  type: PermissionRoleActions.SET_PERMISSION_IN_ROLE,
  payload
})
